import Api from "@/services/Api";

let controller = 'game_packs';

export default {
  index() {
    return Api().get(controller);
  }
};
